//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
import { clientQuery } from 'Core/data/GraphQLApi';

import moment from 'moment';

import {
  TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA
} from 'Redux/actionTypes';

import {
  troubleShootingEventsTabGetDataResult
} from 'Redux/actions';
import { filter } from 'lodash';

function* geTroubleShootingEventsTabDataAsync({ payload }) {
  try {

    const { deviceId, accountId, nextToken, filters, limit, conditions } = payload;

    let ROWDATA = "";
    let data = { getEventData: [] };
    let DateFrom, DateTo;
    let queryParams = {};
    let nxtToken = null;


    const isRangeMode = !!filters.startDate;

    ROWDATA = `
        query ($accountId: String!, $deviceId: String!, $dateRange: AWSDateTimeRange, $limit: Int, $lastRecords: Int, $conditions: [ TroubleshootingEventSearchInput ], $nextToken: String){
            result: searchTroubleshootingEvents(accountId: $accountId, deviceId: $deviceId, dateRange: $dateRange, limit: $limit, lastRecords: $lastRecords, conditions: $conditions, nextToken: $nextToken) {
              items
              nextToken
            }
        }    
        `;

    queryParams = {
      deviceId: deviceId + "",
      accountId: accountId + "",
      nextToken: nextToken,
      conditions: filters?.conditions
    }

    // Last N mode → lastRecords, Range mode → limit
    if (isRangeMode) {
      queryParams.limit = limit;
    } else {
      queryParams.lastRecords = limit;
    }

    if (isRangeMode) {
      DateFrom = filters.startDate
      DateTo = filters.endDate
      queryParams.dateRange = { start: DateFrom, end: DateTo };
    }

    data = yield call(
      clientQuery,
      ROWDATA,
      queryParams,
      endpoints.GRAPHQL_GENERAL
    );

    let result = []
    if (data?.result?.items?.length > 0 && data?.result?.items !== "[]") {
      result = JSON.parse(data?.result?.items);
      nxtToken = data?.result?.nextToken;
    } 
    
    yield put(troubleShootingEventsTabGetDataResult({ items: result, nextToken: nxtToken, oldNextToken: nextToken, conditions: queryParams }));

  } catch (exc) {
    yield put(troubleShootingEventsTabGetDataResult({ error: exc }));
    ExceptionManager(exc, "Modules/devices/.components/troubleShootingEventsTab/redux/saga/", "geTroubleShootingEventsTabDataAsync", true)
  }
}

function* watchMethods() {
  yield takeEvery(TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA, geTroubleShootingEventsTabDataAsync);
}

export default function* rootSaga() {
  yield all([fork(watchMethods)]);
}